"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.makeSignOperation = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var hw_transport_1 = require("@ledgerhq/hw-transport");
var errors_1 = require("@ledgerhq/errors");
var logs_1 = require("@ledgerhq/logs");
var deviceAccess_1 = require("../hw/deviceAccess");
var transaction_1 = require("../transaction");
var getCoreAccount_1 = require("./getCoreAccount");
var errors_2 = require("./errors");
var access_1 = require("./access");
var makeSignOperation = function (_a) {
    var buildTransaction = _a.buildTransaction, signTransaction = _a.signTransaction;
    return function (_a) {
        var account = _a.account, transaction = _a.transaction, deviceId = _a.deviceId;
        return rxjs_1.Observable.create(function (o) {
            var cancelled = false;
            (0, access_1.withLibcore)(function (core) { return __awaiter(void 0, void 0, void 0, function () {
                var currency, derivationMode, _a, coreAccount, coreWallet, coreCurrency, builded, signedOperation;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (cancelled)
                                return [2 /*return*/];
                            currency = account.currency, derivationMode = account.derivationMode;
                            return [4 /*yield*/, (0, getCoreAccount_1.getCoreAccount)(core, account)];
                        case 1:
                            _a = _b.sent(), coreAccount = _a.coreAccount, coreWallet = _a.coreWallet;
                            if (cancelled)
                                return [2 /*return*/];
                            return [4 /*yield*/, coreWallet.getCurrency()];
                        case 2:
                            coreCurrency = _b.sent();
                            if (cancelled)
                                return [2 /*return*/];
                            (0, logs_1.log)("libcore", "buildTransaction", (0, transaction_1.toTransactionRaw)(transaction));
                            return [4 /*yield*/, buildTransaction({
                                    account: account,
                                    core: core,
                                    coreCurrency: coreCurrency,
                                    coreAccount: coreAccount,
                                    transaction: transaction,
                                    coreWallet: coreWallet,
                                    isPartial: false,
                                    isCancelled: function () { return cancelled; }
                                })];
                        case 3:
                            builded = _b.sent();
                            if (cancelled || !builded)
                                return [2 /*return*/];
                            return [4 /*yield*/, (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
                                    return (0, rxjs_1.from)(signTransaction({
                                        account: account,
                                        subAccountId: transaction.subAccountId,
                                        transport: transport,
                                        currency: currency,
                                        derivationMode: derivationMode,
                                        coreCurrency: coreCurrency,
                                        coreAccount: coreAccount,
                                        transaction: transaction,
                                        coreTransaction: builded,
                                        isCancelled: function () { return cancelled; },
                                        onDeviceStreaming: function (_a) {
                                            var progress = _a.progress, index = _a.index, total = _a.total;
                                            return o.next({
                                                type: "device-streaming",
                                                progress: progress,
                                                index: index,
                                                total: total
                                            });
                                        },
                                        onDeviceSignatureRequested: function () {
                                            return o.next({
                                                type: "device-signature-requested"
                                            });
                                        },
                                        onDeviceSignatureGranted: function () {
                                            return o.next({
                                                type: "device-signature-granted"
                                            });
                                        }
                                    })["catch"](function (e) {
                                        // TODO where to remap this generically???
                                        if (e && e.statusCode === hw_transport_1.StatusCodes.INCORRECT_P1_P2) {
                                            throw new errors_1.UpdateYourApp("UpdateYourApp ".concat(currency.id), currency);
                                        }
                                        throw e;
                                    }));
                                }).toPromise()];
                        case 4:
                            signedOperation = _b.sent();
                            if (cancelled || !signedOperation)
                                return [2 /*return*/];
                            o.next({
                                type: "signed",
                                signedOperation: signedOperation
                            });
                            return [2 /*return*/];
                    }
                });
            }); }).then(function () { return o.complete(); }, function (e) { return o.error((0, errors_2.remapLibcoreErrors)(e)); });
            return function () {
                cancelled = true;
            };
        }).pipe((0, operators_1.tap)(function (e) {
            return (0, logs_1.log)("signOperation", "event " + e.type, (0, transaction_1.toSignOperationEventRaw)(e));
        }));
    };
};
exports.makeSignOperation = makeSignOperation;
//# sourceMappingURL=signOperation.js.map